var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSpaceBgChangeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.4889 8.26818L13.7111 4.53485L14.9556 3.29041C15.2963 2.94967 15.715 2.7793 16.2116 2.7793C16.7076 2.7793 17.1259 2.94967 17.4667 3.29041L18.7111 4.53485C19.0519 4.87559 19.2296 5.28685 19.2444 5.76863C19.2593 6.24981 19.0963 6.66078 18.7556 7.00152L17.4889 8.26818ZM16.2 9.57929L6.77778 19.0015H3V15.2237L12.4222 5.80152L16.2 9.57929Z",
    fill: "#8898A6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpaceBgChangeIcon);
export default __webpack_public_path__ + "static/media/space-bg-change-icon.7c0062e75e7763d453f727a569e14ef9.svg";
export { ForwardRef as ReactComponent };